import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../nav-logo.png";
import Twitter from "../../imgs/twitter.png";
import discord from "../../imgs/discord.png";
import panda from "../../imgs/panda-1.png";
export default class Navbar extends Component {
  closeNav = () => {
    let toggleBtn = document.querySelector(".icon--menu-toggle");
    toggleBtn.click();
  };
  render() {
    return (
      <div>
        <div className="navbar d-flex flex-row align-items-center justify-content-between cust-mb">
          {/* <h6 className="text-dark text-lg losnello mb-0 mt-2">DG Labs</h6> */}
          <Link to="/">
            <img className="img-fluid nav-logo" src={Logo} />
          </Link>
          <div className="d-flex flex-row align-items-center">
            <a className="black-btn text-md regular me-5">Connect</a>
            <input
              id="page-nav-toggle"
              className="main-navigation-toggle"
              type="checkbox"
            />
            <label htmlFor="page-nav-toggle">
              <a className="black-btn  text-md icon--menu-toggle regular">
                Menu
              </a>
            </label>
            <a target="_blank" href="https://twitter.com/dopegallerylabs">
              <img className="nav-icon ms-5" src={Twitter} />
            </a>
            <a target="_blank" href="https://discord.gg/dopegallerylabs">
              <img className="nav-icon" src={discord} />
            </a>
            <nav className="main-navigation flex-column align-items-start ">
              <div></div>
              <div className="row w-100 nav-container ">
                <div className="w-100 line-bottom">
                  <img className="img-fluid nav-logo" src={Logo} />
                  <h6 className="text-xl losnello">DGLABS</h6>
                </div>
                <div className="col-md-4">
                  <h6 className="text-lg text-dark losnello">Website</h6>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href="thedopegallery.com"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            GSTAKIS Art Website
                          </p>
                          <p className="text-sm text-dark  ">
                            {" "}
                            GSTAKIS' Original Artwork Website - Merch &
                            Figurines
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <Link
                      className="px-0"
                      onClick={() => this.closeNav()}
                      to="/about"
                      href="#0"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            About Us
                          </p>
                          <p className="text-sm text-dark  ">
                            Get to know the Founders
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>

                  <li>
                    <Link
                      className="px-0"
                      onClick={() => this.closeNav()}
                      to="/roadmap"
                      href="#0"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Roadmap
                          </p>
                          <p className="text-sm text-dark  ">
                            What the future holds
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>

                  <li>
                    <Link
                      className="px-0"
                      onClick={() => this.closeNav()}
                      to="/"
                      href="#0"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Home
                          </p>
                          <p className="text-sm text-dark  ">Homepage</p>
                        </div>
                      </div>
                    </Link>
                  </li>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href="https://magiceden.io/launchpad/3d_intergalactic_pandas"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            3D Intergalactic Panda Launch Page
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </div>

                <div className="col-md-4">
                  <h6 className="text-lg text-dark losnello">Socials</h6>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href="https://twitter.com/dopegallerylabs"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Twitter
                          </p>
                          <p className="text-sm text-dark  ">
                            Stay up to date on project info
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href="https://discord.gg/dopegallerylabs"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Discord
                          </p>
                          <p className="text-sm text-dark  ">
                            Come vibe with us
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <Link
                      className="px-0"
                      onClick={() => this.closeNav()}
                      to="/"
                      href="#0"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Instagram
                          </p>
                          <p className="text-sm text-dark  "></p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </div>

                <div className="col-md-4">
                  <h6 className="text-lg text-dark losnello">Rarity/Market</h6>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href="https://moonrank.app/collection/777_dope_pandas"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Rarity
                          </p>
                          <p className="text-sm text-dark  ">
                            See how rare your Dope Pandas are!
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href=" https://magiceden.io/marketplace/777_dope_pandas"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Marketplace
                          </p>
                          <p className="text-sm text-dark  ">
                            {" "}
                            Magic Eden listing
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a
                      className="px-0"
                      onClick={() => this.closeNav()}
                      href="https://drive.google.com/file/d/1W-SGzNHNjOI_oFtQ5JK9JSereRe2ggIP/view?usp=sharing"
                    >
                      <div className="d-flex flex-row align-items-center">
                        <img className="nav-img" src={panda} />
                        <div className="d-flex flex-column align-items-start">
                          <p className="text-md text-dark losnello nav-title">
                            Dopepaper
                          </p>
                          <p className="text-sm text-dark  ">
                            Our litepaper - learn more about what we're building
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </div>
              </div>
              {/* <ul>
                <li>
                  <Link onClick={() => this.closeNav()} to="/" href="#0">
                    Home
                  </Link>
                </li>
                <li>
                  <Link onClick={() => this.closeNav()} to="/about" href="#0">
                    About
                  </Link>
                </li>
                <li>
                  <a
                    onClick={() => this.closeNav()}
                    href="https://thedopegallery.com/"
                  >
                    Shop
                  </a>
                </li>
                <li>
                  <Link
                    onClick={() => this.closeNav()}
                    to="/comingsoon"
                    href="#0"
                  >
                    Staking
                  </Link>
                </li>
                <li>
                  <Link onClick={() => this.closeNav()} to="/roadmap" href="#0">
                    Roadmap
                  </Link>
                </li>
              </ul> */}
            </nav>
          </div>
        </div>
      </div>
    );
  }
}
